import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import LoadingCircle from "../../components/Common/LoadingCircle";
import LandingPageHeader from "../../components/LandingPage/LandingPageHeader";
import PartnerCard from "../../components/Partner/PartnerCard";
import PartnerSpecialCard from "../../components/Partner/PartnerSpecialCard";
import { getDataByAll } from "../../api/partnerApi";

const Partner = ({ bgColor = "bg-white" }) => {
  const [mainPartners, setMainPartners] = useState([]);
  const [specialPartners, setSpecialPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getDataByAll("main"),
      getDataByAll("special")
    ])
      .then(([mainData, specialData]) => {
        setMainPartners(mainData);
        setSpecialPartners(specialData);
      })
      .catch((err) => console.error("Failed to fetch partners:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section id="partner" className="py-20 flex flex-col items-center justify-center min-h-[400px]">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving Data...
        </p>
      </section>
    );
  }

  return (
    <section 
      id="partner" 
      className={`py-6 md:py-10 scroll-mt-24 lg:scroll-mt-44 ${bgColor} transition-colors`}
    >
      <div className="container mx-auto px-4 max-w-7xl">     
        {/* Header Section */}
        <div className="-mt-2 md:-mt-4 mb-12 md:mb-16">
          <LandingPageHeader 
            icon={MapPin} 
            title="Our Valuable Partners" 
            subtitle="Global Networks & Collaborations" 
            center={true} 
          />
        </div>

        {/* Card Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-y-16 gap-x-12 justify-items-center items-center">
          {mainPartners.map((item, i) => (
            <PartnerCard 
              key={i} 
              logo={item.imageUrl}
              name={item.val} 
            />
          ))}
        </div>

        {/* Divider dengan Spacing Atas lebih besar dari Bawah */}
        <hr className="mt-28 mb-12 border-slate-100 dark:border-slate-800/60" />

        {/* Grid Special Partners (3 Kolom) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 text-center">
          {specialPartners.map((item, i) => (
            <PartnerSpecialCard 
              key={i}
              label={item.label}
              logo={item.imageUrl}
              name={item.val}
              subtitle={item.sub}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partner;